import axios from 'axios';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1').replace(/\/+$/, '');

const portalApi = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const extractPortalToken = (hash = '') => String(hash || '').replace(/^#/, '');

export const verifyApprovalPortal = ({ token, npiLast4 = '' }) =>
  portalApi.post('/approvals/portal/verify/', {
    token,
    npi_last4: npiLast4,
  });

export const listApprovalPortalDocuments = () =>
  portalApi.get('/approvals/portal/documents/');

export const getApprovalPortalDocumentUrl = (documentId) =>
  portalApi.get(`/approvals/portal/documents/${documentId}/url/`);

export const signApprovalPortal = ({
  signatureData,
  signatureMethod = 'typed',
}) =>
  portalApi.post('/approvals/portal/sign/', {
    signature_method: signatureMethod,
    signature_data: signatureData,
  });

export const declineApprovalPortal = ({
  declineKind = 'other',
  declineReason,
  perDocNotes = {},
}) =>
  portalApi.post('/approvals/portal/decline/', {
    decline_kind: declineKind,
    decline_reason: declineReason,
    per_doc_notes: perDocNotes,
  });
